import Navigation from "./Navigation";
import { motion } from "framer-motion";

export default function MainLayout({ children, currentTab, onTabChange }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50">
      <Navigation currentTab={currentTab} onTabChange={onTabChange} />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.main>
    </div>
  );
}
